// extracted by mini-css-extract-plugin
export default {"navigationOption":"Navigation_navigationOption__SRZJR","logoAlign":"Navigation_logoAlign__gGybk","nkNavbar":"Navigation_nkNavbar__p4TNS"};